import React, { ReactElement } from 'react'

type BasketSectionHeaderProps = {
  content: string[];
}

const BasketSectionHeader = ({ content }: BasketSectionHeaderProps): ReactElement => (
  <>
    <div className="basketTableBuyAndHireSectionHeader">{content[0]}</div>
    <div className="new-basket-table-headers">
      <div className="basket-table-header">
        <span>Product</span>
      </div>
      <div className="basket-table-header">
        <span>&nbsp;</span>
      </div>
      <div className="basket-table-header">
        <span>Weight</span>
      </div>
      <div className="basket-table-header">
        <span>{content[1]}</span>
      </div>
      <div className="basket-table-header">
        <span>{content[2]}</span>
      </div>
      <div className="basket-table-header">
        <span>Total</span>
      </div>
    </div>
    </>
)

export default BasketSectionHeader
